import { toast } from "react-toastify";
import { endpoints, oids } from "../../../../configs/Settings";
import { HTTPResponseStatus } from "../../../../utils/enum";

import { useAuth } from "../../../../utils/useAuth";
import { useAxios } from "../../../../utils/useAxios";
import { auxiliarData } from "../../AuxiliarData";
import { ITaskData } from "@/utils/interfaces";
import { PostTask } from "../../task/PostTask";

export async function PostMedicationRequest(
  objData: any,
  encounter?: any,
  source?: any
) {
  let url = `${endpoints.EHRPOSTER}/`;

  const data = auxiliarData.MedicationRequest(objData, encounter, source);
  const headers = {
    Accept: "application/fhir+json",
    Authorization: await useAuth.getUserToken(),
    "Content-Type": "application/fhir+json",
  };

  const response = await useAxios
    .post(url, data, { headers, timeout: 20000 })
    .then((response) => {
      if (
        response.status !== HTTPResponseStatus.Created &&
        response.status !== HTTPResponseStatus.Success
      ) {
        throw new Error(`PostMedicationRequest: ${response.status}`);
      }

      if (encounter?.requester) {
        // Task só em receita nova; órfãos de edição (já têm medicationRequestId) não criam Task de novo
        const isFreshPrescription = objData?.some(
          (el: any) => !el?.medicationRequestId
        );
        if (isFreshPrescription) {
          const taskData: ITaskData = {
            status: "requested",
            intent: "order",
            priority: "routine",
            description: `O médico ${encounter.requester.display} receitou o medicamento ${objData?.[0]?.name}`,

            owner: encounter?.requester?.reference,
            for: `Patient/${oids.cpf}-${encounter?.subject}`,
          };

          // Cria a tarefa utilizando o PostTask
          PostTask(taskData);
        }
      }
      return response.data;
    })
    .catch((error) => {
      console.error("PostMedicationRequest ", error);
      // toast.error(`PostMedicationRequest Error: ${error?.response?.status}`);
      throw new Error();
    });

  if (response) return response;
}
